module.exports = __webpack_public_path__ + "static/media/ctm.b1ebb57a.svg";